import { AfterViewInit, Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DocumentEditorContainerComponent, ToolbarService } from '@syncfusion/ej2-angular-documenteditor';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';
import { registerLicense } from '@syncfusion/ej2-base';
import { RequestModel } from '../../../models/request/request-model';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';

registerLicense("Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlfcnRSRGdYUkVzWUQ=")

@Component({
    selector: 'sem-document-editor',
    providers: [ToolbarService],
    templateUrl: './sem-document-editor.component.html',
    styleUrl: './sem-document-editor.component.css',
    standalone: false
})
export class SemDocumentEditorComponent extends ValueAccessorBase<string> implements OnInit, AfterViewInit, OnDestroy {

  @Input() documentUrlParameter;
  @Input() documentUrl;

  public hostUrl: string = environment.wgProfileHost + '/api/public/';
  @ViewChild('documenteditor_default')
  public container: DocumentEditorContainerComponent;
  public culture: string = 'en-US';

  private modelSubscription: Subscription;
  private isDocumentEditorReady = false;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.subscribeToModelChanges();
  }

  ngOnDestroy(): void {
    if (this.modelSubscription) {
      this.modelSubscription.unsubscribe();
    }
  }

  onCreate() {
    console.log('DocumentEditor created and ready');
    this.isDocumentEditorReady = true;

    // Set document to read-only since this is for viewing
    this.container.documentEditor.isReadOnly = true;
    this.container.showPropertiesPane = false;
    this.container.enableToolbar = false;
  }

  onDocumentChange() {
  }

  private subscribeToModelChanges() {
    this.modelSubscription = this.restProviderService.modelValueChanged.subscribe((model: any) => {

      if (model?.Id > 0 && model?.Medias?.length > 0) {
        this.loadDocumentFromModel(model);
      }
    });
  }

  private loadDocumentFromModel(model: any) {
    try {
      // Set default document parameter if not provided
      if (!this.documentUrlParameter) {
        this.documentUrlParameter = 50;
      }

      // Find the correct media file
      const media = this.getLastSectionWithType(model.Medias);

      if (!media) {
        return;
      }

      //console.log('Loading document from media:', media.Name);

      // Get the file data
      let requestModel = new RequestModel();
      requestModel.url = "api/media/getfile";
      requestModel.data = {
        Id: media.FileID,
        FileName: media.Name,
        ReturnFullSize: true
      };

      this.restProviderService.getDataPOST(requestModel).subscribe({
        next: (data: any) => {
          this.loadDocumentFromMediaData(data, media.Name);
        },
        error: (error) => {
          this.showErrorMessage('Failed to load document data');
        }
      });

    } catch (error) {
      this.showErrorMessage('Error processing document');
    }
  }

  private getLastSectionWithType(sections: any[]) {
    // Sort by ID and filter by document type
    const sortedSections = sections.sort((a, b) => a.Id - b.Id);
    const filteredSections = sortedSections.filter(section =>
      section.FileSectionType == this.documentUrlParameter);

    return filteredSections.length > 0 ? filteredSections[filteredSections.length - 1] : null;
  }

  private loadDocumentFromMediaData(mediaData: any, fileName: string) {
    try {

      if (!this.isDocumentEditorReady) {
        setTimeout(() => this.loadDocumentFromMediaData(mediaData, fileName), 100);
        return;
      }

      if (!mediaData || !mediaData.Base64) {
        this.showErrorMessage('Invalid document data');
        return;
      }

      // Convert base64 to file
      const base64Data = mediaData.Base64;
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const file = new File([byteArray], fileName, {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });


      // Send to Import API
      const formData = new FormData();
      formData.append('files', file);


      fetch(this.hostUrl + 'Import', {
        method: 'POST',
        body: formData
      })
      .then(response => {

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return response.text();
      })
      .then(sfdtData => {

        if (!sfdtData || sfdtData.trim() === '') {
          throw new Error('Empty SFDT response from server');
        }

        // Validate JSON
        try {
          JSON.parse(sfdtData);
        } catch (e) {
          throw new Error('Invalid SFDT format received');
        }

        // Open the document
        this.container.documentEditor.open(sfdtData);
      })
      .catch(error => {
        this.showErrorMessage(`Error loading document: ${error.message}`);
      });

    } catch (error) {
      this.showErrorMessage('Failed to process document');
    }
  }

  private showErrorMessage(message: string) {
    try {
      if (this.isDocumentEditorReady && this.container?.documentEditor) {
        this.container.documentEditor.openBlank();
        this.container.documentEditor.editor.insertText(message);
      }
    } catch (error) {
    }
  }
}